export const OVERVIEW_FILTERS_DATA = "OVERVIEW_FILTERS_DATA";
export const OVERVIEW_FILTERS_LOADED = "OVERVIEW_FILTERS_LOADED";
export const OVERVIEW_FILTERS_ERROR = "OVERVIEW_FILTERS_ERROR";
export const OVERVIEW_FILTERS_APPLIED = "OVERVIEW_FILTERS_APPLIED";

const defaultState = {
	data: null,
	loaded: false,
	error: null,
	applied: {}
};

export default function overviewFiltersReducer(state = defaultState, action) {
	switch (action.type) {
		case OVERVIEW_FILTERS_DATA:
			return { ...state, data: action.payload };
		case OVERVIEW_FILTERS_LOADED:
			return { ...state, loaded: action.payload };
		case OVERVIEW_FILTERS_ERROR:
			return { ...state, error: action.payload };
		case OVERVIEW_FILTERS_APPLIED:
			return { ...state, applied: { ...state.applied, ...action.payload } };
		default:
			return state;
	}
}